import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import NaturalIngredientsContent from './components/NaturalIngredientsContent';

export default function NaturalIngredientsPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '天然原料｜動物・植物・菇蕈・藻類・生化原料分類｜康永生技',
    description: '康永生技天然原料分類：動物來源（膠原蛋白/魚油）、植物來源（薑黃素/蔓越莓）、菇蕈來源（靈芝/牛樟芝）、藻類油脂、生化類群及其他營養來源。',
    keywords: '天然原料,保健食品原料,植物原料,動物原料,菇蕈原料,藻類原料,生化原料',
    lang: 'zh-TW',
    canonicalPath: '/services/natural-ingredients',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="天然原料｜動物・植物・菇蕈・藻類・生化原料分類｜康永生技" pageDescription="康永生技天然原料分類：動物來源（膠原蛋白/魚油）、植物來源（薑黃素/蔓越莓）、菇蕈來源（靈芝/牛樟芝）、藻類油脂、生化類群及其他營養來源。" pageUrl={`${siteUrl}/services/natural-ingredients`} />
      <NaturalIngredientsContent />
    </Layout>
  );
}